import { StyledTable } from './styles';

export const Table = StyledTable;

export default Table;
